import axios from 'axios';

import config from '../config';
import { validateToken } from '@utils/isTokenExpired';
import { GetTableSoilInfoRequestPayload } from '@mytypes/soil';

export const getSoilTableApi = async (payload: GetTableSoilInfoRequestPayload): Promise<string | undefined> => {
  try {
    if (!(await validateToken())) {
      return;
    }

    let formData = new FormData();
    formData.append('table_guid', payload.tableGuid);
    formData.append('format', 'json');
    const { data } = await axios({
      url: `${config.REACT_APP_INSIGHTS_SERVICE_URL}/ssurgo`,
      method: 'post',
      data: formData,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`
      }
    });

    return data as string;
  } catch (error) {
    console.log(error);
  }
};
